<template>
  <v-flex class="pa-4" data-qa="services-flex-40pw5f">
    {{'Services'}}
  </v-flex>
</template>

<script>

export default {
  name: 'Services'
}
</script>
